export const TILE_MATCH_TOTAL_ROUNDS = 10;
export const TILE_MATCH_BAR_CAPACITY = 7;

/** Run timer (seconds), aligned with Genius solo round limit. */
export const TILE_MATCH_TIME_LIMIT_SECONDS = 30;

/** Seconds added to the run timer when a trio is cleared. */
export const TILE_MATCH_TRIO_TIME_BONUS_SECONDS = 3;

/** Points for clearing a round (0-based index). Must match TileMatchEngine.PointsForRound on the API. */
export function tileMatchPointsForRound(roundIndexZeroBased: number): number {
  switch (roundIndexZeroBased) {
    case 9:
      return 30;
    case 8:
      return 25;
    case 7:
      return 20;
    case 6:
      return 15;
    case 5:
      return 8;
    case 4:
      return 6;
    case 3:
      return 5;
    default:
      return 2;
  }
}
